angular.module('zc')
  .component('zcIwNavigation', {
    templateUrl: '/templates/projects.iw/iw_navigation.html',
    bindings: {
      project: '<'
    }
  });



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.iw/iw_navigation.js